import { request } from '@/utils/request';

/**
 * 模板相关api
 */
/**
 * 获取全部服务列表
 * @param params
 * @param payload
 * @returns
 */
export const _getAllServices = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getAllServices', params, payload);
};
/**
 * 保存或者新建服务
 * @param params
 * @param payload
 * @returns
 */
export const _saveService = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/saveService', params, payload);
};
/**
 * 获取单个服务类型下的全部模板数据(包含基本信息即可)
 * @param params
 * @param payload
 * @returns
 */
export const _getAllTemplatesOfService = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getAllTemplatesOfService', params, payload);
};
/**
 * 获取单个服务类型下的全部模板数据(包含基本信息即可)
 * 2.0合并1.0数据版本
 * @param params
 * @param payload
 * @returns
 */
export const _getAllTemplatesOfServiceV2 = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getAllTemplatesOfServiceV2', params, payload);
};
/**
 * 删除模板
 * @param params
 * @param payload
 * @returns
 */
export const _deleteTemplate = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/delete', params, payload);
};
/**
 * 获取模板基本信息
 * @param params
 * @param payload
 * @returns
 */
export const _getBase = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getBase', params, payload);
};
/**
 * 保存模板基础数据
 * @param params
 * @param payload
 * @returns
 */
export const _saveBase = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/saveBase', params, payload);
};
/**
 * 获取模板接口文档
 * @param params
 * @param payload
 * @returns
 */
export const _getInterfaceDoc = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getInterfaceDoc', params, payload);
};
/**
 * 保存模板接口文档
 * @param params
 * @param payload
 * @returns
 */
export const _saveInterfaceDoc = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/saveInterfaceDoc', params, payload);
};
/**
 * 获取模板日志规范文档
 * @param params
 * @param payload
 * @returns
 */
export const _getLogDoc = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getLogDoc', params, payload);
};
/**
 * 保存模板日志规范文档
 * @param params
 * @param payload
 * @returns
 */
export const _saveLogDoc = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/saveLogDoc', params, payload);
};

/**
 * 获取模板系统配置
 * @param params
 * @param payload
 * @returns
 */
export const _getSystemConfig = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getSysTemConfig', params, payload);
};
/**
 * 保存模板系统配置
 * @param params
 * @param payload
 * @returns
 */
export const _saveSystemConfig = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/saveSysTemConfig', params, payload);
};
/**
 * 禁用模板
 * @param params
 * @param payload
 * @returns
 */
export const _templateDisable = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/disable', params, payload);
};
/**
 * 启用模板
 * @param params
 * @param payload
 * @returns
 */
export const _templateEnable = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/enable', params, payload);
};
/**
 * 获取活动配置
 * @param params
 * @param payload
 * @returns
 */
export const _getActivityConfig = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getActivityConfig', params, payload);
};
/**
 * 保存活动配置
 * @param params
 * @param payload
 * @returns
 */
export const _saveActivityConfig = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/saveActivityConfig', params, payload);
};

/**
 * 获取卡片类型配置列表
 * @param params
 * @param payload
 * @returns
 */
export const _getCardTypes = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getCardTypes', params, payload);
};

/**
 * 获取测试发布
 * @param params
 * @param payload
 * @returns
 */
export const _getTest = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getTest', params, payload);
};
/**
 * 保存测试发布
 * @param params
 * @param payload
 * @returns
 */
export const _saveTest = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/saveTest', params, payload);
};
/**
 * 获取模板中某个卡片id的配置数据
 * @param params
 * @param payload
 * @returns
 */
export const _getTemplateCard = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getCard', params, payload);
};
/**
 * 复制单个模板
 * @param params
 * @param payload
 * @returns
 */
export const _copyTemplate = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/copyTemplate', params, payload);
};
export const _saveServiceDoc = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/saveServiceDoc', params, payload);
};

export const _getServiceDocList = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getServiceDocList', params, payload);
};
export const _saveTestToolDoc = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/saveTestToolDoc', params, payload);
};
export const _getTestToolDocList = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getTestToolDocList', params, payload);
};

// 自动生成活动id
export const _autoGenerateId = (params?: { id: number }, payload?: Request.IPayload) => {
  return request('/hermes/template/autoGenerateId', params, payload);
};

// 获取应用场景
export const _getServiceScence = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getServiceScence', params, payload);
};

// 筛选应用场景下的card
export const _getAllServicesV2 = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/template/getAllServicesV2', params, payload);
};
